import { render, staticRenderFns } from "./VDialogActions.vue?vue&type=template&id=39bce1ca"
import script from "./VDialogActions.vue?vue&type=script&lang=js"
export * from "./VDialogActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports